module.exports = __webpack_public_path__ + "static/media/grin-regular.b7b05d88.svg";